var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rkm-tabs',[_c('rkm-tab',{attrs:{"title":"Base Nacional"}},[_c('TabBaseNacional',{ref:"TabBaseNacional",on:{"select":_vm.handleSelect}})],1),_c('rkm-tab',{attrs:{"title":"Base Local"}},[_c('TabBaseLocal',{ref:"TabBaseLocal",on:{"select":_vm.handleSelect}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }